import * as React from 'react';
import styled from 'styled-components';
import { media, Icon } from '@packages/ui';
import { Arrow, ArrowProps } from '../Arrow/Arrow';

// TODO: fix z index
const ArrowRightStyled = styled(Arrow).attrs({ 'data-testid': 'arrow-right' })<{ elevation: number | number[] }>`
  border-radius: 45%;
  padding-left: 11px;
  position: absolute;
  bottom: calc(50% - 20px);
  right: 0px;
  z-index: 100;
  ${media.to.md`
    display: none;
 `}
`;

export const ArrowRight: React.FC<
  ArrowProps & {
    disabled?: boolean;
    onClick?: (event: MouseEvent) => void;
  }
> = ({ className, disabled, onClick }) => {
  return (
    <ArrowRightStyled disabled={disabled} elevation={2} className={className} onClick={onClick as any}>
      <Icon size={16} color="white" name="chevronRight" />
    </ArrowRightStyled>
  );
};
